import {IComponentOptions} from 'angular';
import {IStateService} from 'angular-ui-router';
import ErrorService from '../../../core/errors/service/ErrorService';
import BenutzerRS from '../../../core/service/BenutzerRS.rest';
import PasswordStrengthService from '../../../core/service/PasswordStrengthService';
import RoleUtilService from '../../../core/service/RoleUtilService';
import AbstractGesuchViewController from '../../../gesuch/component/abstractModelController';
import {rolePrefix, TSRole} from '../../../models/enums/TSRole';
import TSBenutzer from '../../../models/TSBenutzer';
import {IAnlaufstelleBenutzerEditStateParams} from '../../benutzerverwaltung.route';
import './benutzerEditView.scss';
import ILogService = angular.ILogService;
import IScope = angular.IScope;
import IWindowService = angular.IWindowService;
import ITranslateService = angular.translate.ITranslateService;

let template = require('./benutzerEditView.html');

export class BenutzerEditComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = BenutzerEditViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        benutzer: '<',
    };
}

export class BenutzerEditViewController extends AbstractGesuchViewController<TSBenutzer> {

    private benutzer: TSBenutzer;

    private viewReadonly: boolean = false;

    static $inject: string[] = ['$stateParams', '$log', 'ErrorService', '$window', '$state',
        'PasswordStrengthService', '$scope', 'RoleUtilService', '$translate', 'BenutzerRS'];

    /* @ngInject */
    constructor(private $stateParams: IAnlaufstelleBenutzerEditStateParams,
                private $log: ILogService, private errorService: ErrorService,
                private $window: IWindowService, private $state: IStateService,
                private passwordStrengthService: PasswordStrengthService, $scope: IScope,
                private roleUtilService: RoleUtilService, private $translate: ITranslateService,
                private benutzerRS: BenutzerRS) {

        super($scope);

    }

    $onInit() {
        super.$onInit();
        this.initialModel = this.benutzer;
        this.model = angular.copy(this.benutzer);

    }

    private initModel() {
        //unused
        let benutzer: TSBenutzer = this.initialModel;

        if (benutzer && benutzer.roles.length === 0) {
            //wenn wir keine rollen haben setzen wir mal eine
            benutzer.roles.push(TSRole.UNASSIGNED_ROLE);

        }

    }

    public submit() {
        if (this.form.$valid && this.benutzer && this.checkEmailRepeated()) {

            this.benutzerRS.createOrUpdateBenutzeraccount(this.benutzer).then((storedBenutzer: TSBenutzer) => {
                if (storedBenutzer !== undefined) {
                    if (this.benutzer.isNew()) {
                        // this.benutzer.passwordData = new TSPasswordData(this.benutzer.email);
                        this.errorService.addMesageAsInfoWithArgs('BENUTZER_REC_SUCCESS', this.benutzer.email);
                    } else {
                        if (this.benutzer.email !== storedBenutzer.email) {
                            this.errorService.addMesageAsInfoWithArgs('BENUTZER_UPDATE_EMAIL_INFO', this.benutzer.email);
                        }
                    }
                    this.benutzer = storedBenutzer;
                    this.form.$setPristine();
                    this.form.$setUntouched();
                    this.$state.go('benutzerverwaltung');
                } else {
                    this.$log.error('could not save new benutzer ' + this.benutzer);
                }

            });

        } else {
            this.$log.debug('Form was not valid');
        }

    }

    public cancelBenutzeredit() {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.$state.go('benutzerverwaltung')

    }

    public getRoles(): Array<TSRole> {
        return this.roleUtilService.getAnlaufstelleSubuserRolesOnly();

    }

    public translateRole(val: TSRole): string {
        return this.$translate.instant(rolePrefix() + val);
    }

    private checkEmailRepeated(): boolean {
        let repeatValid = this.benutzer.checkEmailRepeated();
        if (!repeatValid) {
            this.errorService.addMesageAsError('ERROR_EMAIL_SAME');
            return false;
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/benutzerverwaltung/component/benutzerEditView/benutzerEditView.ts